import React from "react";
// import styled from "styled-components";

import Header from "../Components/Header";
import ShareSong from "../Components/ShareSong";
import Artists from "../Components/Artists";
import { icons } from "../Components/Button";

export default props => {
  if (!props.songs) {
    return <div />
  }
  console.log(props);
  return (
    <div>
      <Header
        title="Recently played"
        donePath={'/player'}
        border={true}
      />
      <div>
        {props.songs && (
          <ul style={{ maxWidth: '35rem', margin: '0 auto', width: '100%' }}>
            {props.songs.map((song, i) => {
              const date = typeof song.date === 'string' ? new Date(song.date).toLocaleDateString() : song.date.toLocaleDateString();


              return (
                <li
                  key={i}
                  style={{
                    display: "flex",
                    alignItems: 'center',
                    borderBottom: "1px solid #ccc",
                    padding: "1rem 1rem"
                  }}
                >
                  <div style={{ flex: 1 }}>
                    <h3 className="book" style={{ flex: 1, marginBottom: '.25rem' }}>{song.track.name}</h3>
                    <span style={{ color: '#999' }}><Artists artists={song.track.artists} /></span>
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'column', marginRight: '1rem' }}>
                    {date !== new Date().toLocaleDateString() && <span>{date}</span>}
                    <span>{typeof song.date === 'string' ? new Date(song.date).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : song.date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</span>
                  </div>
                  <ShareSong song={song.track} icon={icons.share} style={{ height: '20px', width: '20px' }} />
                </li>
              )
            })}
          </ul>
        )}
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/Views/RecentlyPlayed.js